export default {
    loggedIn(state:any, isLoggedIn:any) {
        state.isLoggedIn = isLoggedIn
    },
    urlAvatar(state:any, isUrlAvatar:any) {
        state.isUrlAvatar = isUrlAvatar
    },
    loading(state:any, isLoading:any) {
        state.isLoading = isLoading
    },
};
